import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Swipeable from 'react-swipeable';

export default class Modal extends React.Component {
    constructor(props) {
        super(props);
        this._handleClose = this._handleClose.bind(this);
        this._handlePrev = this._handlePrev.bind(this);
        this._handleNext = this._handleNext.bind(this);
        this._handleSwipeLeft = this._handleSwipeLeft.bind(this);
        this._handleSwipeRight = this._handleSwipeRight.bind(this);
    }

    render() {
        const modalClass = classnames('photo-modal', {
            hide: this.props.index == null,
        });

        return (
            <div id="photo_detail" className={modalClass}>
                <a
                    className="photo-modal__close"
                    href="#"
                    onClick={this._handleClose}
                >
                    ×
                </a>
                <Swipeable
                    className="swipeable photo-modal__detail"
                    trackMouse={true}
                    onSwipedLeft={this._handleSwipeLeft}
                    onSwipedRight={this._handleSwipeRight}
                >
                    {this._renderPhoto()}
                    {this._renderCaption()}
                </Swipeable>
                <ul id="pager">
                    <li
                        id="prev"
                        onClick={this._handlePrev}
                        className="left photo-modal__arrow-left"
                    >
                        <a href="#">
                            <span className="sr-only">前の画像へ</span>
                        </a>
                    </li>
                    <li
                        id="next"
                        onClick={this._handleNext}
                        className="right photo-modal__arrow-right"
                    >
                        <a href="#">
                            <span className="sr-only">次の画像へ</span>
                        </a>
                    </li>
                </ul>
            </div>
        );
    }

    _renderPhoto() {
        if (this.props.index != null) {
            return (
                <div className="swipeable photo-modal__img">
                    <img
                        src={this.props.photo.url.large}
                        id="photo_detail_image"
                        alt=""
                        loading="lazy"
                    />
                </div>
            );
        }

        return null;
    }

    _renderCaption() {
        if (this.props.index == null) {
            return null;
        }

        if (this.props.photo.caption) {
            return (
                <p className="swipeable photo-modal__caption">
                    {this.props.photo.caption}
                </p>
            );
        }

        return null;
    }

    // 一覧へ戻る
    _handleClose(e) {
        e.preventDefault();

        this.props.clickClose();
    }

    // 前へ
    _handlePrev(e) {
        e.preventDefault();

        const index =
            this.props.index == 0 ? this.props.total - 1 : this.props.index - 1;
        this.props.clickPrev(index);
    }

    // 次へ
    _handleNext(e) {
        e.preventDefault();

        const index =
            this.props.index + 1 < this.props.total ? this.props.index + 1 : 0;
        this.props.clickNext(index);
    }

    // 左へ swipe
    _handleSwipeLeft(e, deltaX, isFlick) {
        this._handleNext(e);
    }

    // 右へ swipe
    _handleSwipeRight(e, deltaX, isFlick) {
        this._handlePrev(e);
    }
}

Modal.propTypes = {
    photo: PropTypes.object,
    index: PropTypes.number,
    total: PropTypes.number,
    clickClose: PropTypes.func.isRequired,
    clickPrev: PropTypes.func.isRequired,
    clickNext: PropTypes.func.isRequired,
};
